// extracted by mini-css-extract-plugin
export default {"-large":"tsA8Qfm9ZLfpXYZ4EHfE","title":"FSsr7s47S1M8iS5qFeag","titleError":"IHqtFFkV6vfW8eXqMuYQ","noBorder":"S9MAMzIpj3DdgLJxFXRa"};